import { DashboardCaption } from "../models/dashboard.caption.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getDashboardCaption = (systemId: number): Promise<DashboardCaption> => {
    return new Promise<DashboardCaption>((resolve, reject) => {
        if(!systemId) return;

        responseHero.get(`${process.env.REACT_APP_API_URL}/dashboardcaption/${systemId}`).then((response) => {
            resolve(response.data as DashboardCaption);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};